export const EMAIL_DOMAIN_REGEX =
  /^(?:(?:[a-z0-9\u00A1-\uFFFF](?:[a-z0-9\u00A1-\uFFFF-]{0,61}[a-z0-9\u00A1-\uFFFF])?)\.)+(?:[a-z\u00A1-\uFFFF]{2,}|xn--[a-z0-9-]{2,})$/i;

export const isEmailValid = (email: string = ''): boolean => {
  if (!email || /\s/.test(email)) return false;

  const parts = email.split('@');
  if (parts.length !== 2) return false;

  const [localPart, domain] = parts;

  return (
    Boolean(localPart) &&
    Boolean(domain) &&
    !localPart.startsWith('.') &&
    !localPart.endsWith('.') &&
    !localPart.includes('..') &&
    EMAIL_DOMAIN_REGEX.test(domain)
  );
};

export const restoreLastValidEmail = (
  { email, setCustomerEmail }: { email: string; setCustomerEmail: (email: string) => void },
  lastValidEmail: string
) => {
  if (isEmailValid(email) || !lastValidEmail) return;
  setCustomerEmail(lastValidEmail);
};
